import React, { use } from 'react';
import { HubType } from '../api';
import { ContainerTypeLegacy } from '../util/constant';

export type HubWithColorCode = {
  order: number;
  color: string;
  hub_container_link_id: string;
  hub_id: string;
  alias?: string | null;
  core_id: string;
  container_id: string;
  container_type: ContainerTypeLegacy;
  start_epoch: Date;
  end_epoch: Date;
  nickname: string;
  hub_type: HubType;
  has_level_sensor: boolean;
  hub_offset_ft: number;
};

type TContext = HubWithColorCode[] | null | undefined;

type ActiveHubsWithColorContextValue = {
  activeHubsWithColor: TContext;
  setActiveHubsWithColor: (value: TContext) => void;
};

export const ActiveHubsWithColorContext = React.createContext<ActiveHubsWithColorContextValue>({
  activeHubsWithColor: undefined,
  setActiveHubsWithColor: () => {},
});

export const ActiveHubsWithColor = ({ children }: React.PropsWithChildren) => {
  const [context, setContext] = React.useState<TContext>(undefined);
  const value = React.useMemo(
    () => ({
      activeHubsWithColor: context,
      setActiveHubsWithColor: setContext,
    }),
    [context]
  );

  return <ActiveHubsWithColorContext value={value}>{children}</ActiveHubsWithColorContext>;
};

export function useActiveHubsWithColor() {
  return use(ActiveHubsWithColorContext);
}
